import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpgToTiffConfig } from '@/data/landingConfig/landingJpgToTiffConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpgToTiff } from './schemaObject';

interface Props {}
const JpgToTiffConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpgToTiff} />
			<LandingTemplate
				data={landingJpgToTiffConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpgToTiffConverter;
